import { Service, service, inject } from './di'
import { AccountsService } from './AccountsService'
import { RatingObject } from '../definitions/CommonDefinitions'

@service
export class AppRatingService extends Service {
    @inject accounts: AccountsService

    ratings: RatingObject = null

    async fetchAppRating() {
        this.ratings = await this.accounts.getAppRating()
    }

    getAppRating() {
        return this.ratings
    }
}
